window.InifECShared.factory("$WebTitle", [function () {

    var _factory = {};

    var inifECTitle = 'inif印衣服(巧昱服飾設計有限公司)一件也可印,班服,團體制服,制服設計製造,少量客製化商品 | inif印衣服，巧昱服飾設計有限公司(信箱: service@inif.com.tw)，www.inif.com.tw，一件也可印，班服，團體制服，制服設計製造，少量客製化商品';

    // --------------------------------
    // 改變標題名稱
    // --------------------------------
    var changeWebTitle = function(stateName) {

        var title = inifECTitle;
        
        switch(stateName) {
            case window.STATES.HOME:
            case window.STATES.PAYMENT_RESULT:
            case window.STATES.PAYMENT_SINOPACATM:
            case window.STATES.PAYMENT_SINOPACCREDITCARD:
            case window.STATES.PAYMENT_POINT:
            case window.STATES.PAYMENT_OUTWARDREMITTANCE:
            case window.STATES.PAYMENT_MONTHLY:
            case window.STATES.MEMBER:
            case window.STATES.MAIL_IDENTIFY:
            case window.STATES.RESET_PASSWORD:
            case window.STATES.CHANGE_EMAIL:
            case window.STATES.ACTIVITY_CHECK:
            case window.STATES.PRODUCT_TEMPLATE:
            case window.STATES.SIGNUP:
            case window.STATES.ENTERPRISE_SIGNUP:
                title = inifECTitle;
                break;
            case window.STATES.ALL_PRODUCT:
                title = '全部商品 | inif印衣服，巧昱服飾設計有限公司';
                break;
            case window.STATES.CART:
                title = '購物車 | inif印衣服，巧昱服飾設計有限公司';
                break;
            case window.STATES.PAYMENT:
            case window.STATES.MEMBER_ORDER_LIST:
            case window.STATES.MEMBER_ORDER_LIST_ALL:
            case window.STATES.MEMBER_ORDER_LIST_PAY:
            case window.STATES.MEMBER_ORDER_LIST_DISCARD:
            case window.STATES.MEMBER_ORDER_LIST_SUCCESS:
            case window.STATES.MEMBER_ORDER_HISTORY:
                title = '訂單中心 | inif印衣服，巧昱服飾設計有限公司';
                break;
            case window.STATES.MEMBER_PROFILE:
            case window.STATES.MEMBER_CHANGE_PWD:
            case window.STATES.MEMBER_FAVORITE_ADDRESS:
                title = '帳戶中心 | inif印衣服，巧昱服飾設計有限公司';
                break;
            case window.STATES.MEMBER_SYSTEM_MESSAGE:
                title = '消息中心 | inif印衣服，巧昱服飾設計有限公司';
                break;
            case window.STATES.ABOUT:
                title = '關於我們 | inif印衣服，巧昱服飾設計有限公司';
                break;
            case window.STATES.FAQ:
                title = '常見問題 | inif印衣服，巧昱服飾設計有限公司';
                break;
            case window.STATES.MEMBER_SIGNUP:
                title = '會員註冊 | inif印衣服，巧昱服飾設計有限公司';
                break;
            // case window.STATES.SPECIAL_OFFER:
            //     title = '印衣服詢價 | inif印衣服，巧昱服飾設計有限公司';
            //     break;
            // 這些state更換title在各自的controller做
            case window.STATES.PRODUCT_LIST:
            case window.STATES.PRODUCT:
            case window.STATES.COMPLEX_PDT:
            case window.STATES.FAQ_LIST:
            case window.STATES.BLOG_LIST:
            case window.STATES.RESOURCE_LIST:
            case window.STATES.DESIGNER_LIST:
            case window.STATES.PROJECT_LIST:
            case window.STATES.BLOG_POST:
            case window.STATES.PROJECT_POST:
            case window.STATES.DESIGNER:
                return;
            // mobile
            default:
                title = inifECTitle;
                break;
        }

        setWebTitle(title);
    }

    // --------------------------------
    // 改變mobile標題名稱
    // --------------------------------
    var changeMobileWebTitle = function(stateName) {

        var title = inifECTitle;
        
        switch(stateName) {
            case window.STATES.HOME:
            case window.STATES.PAYMENT_RESULT:
            case window.STATES.PAYMENT_SINOPACCREDITCARD:
            case window.STATES.PAYMENT_POINT:
            case window.STATES.PAYMENT_SINOPACATM:
            case window.STATES.PAYMENT_OUTWARDREMITTANCE:
            case window.STATES.PAYMENT_MONTHLY:
            case window.STATES.MEMBER:
            case window.STATES.MAIL_IDENTIFY:
            case window.STATES.RESET_PASSWORD:
            case window.STATES.CHANGE_EMAIL:
            case window.STATES.ACTIVITY_CHECK:
            case window.STATES.ALL_PRODUCT:
                title = inifECTitle;
                break;
            case window.STATES.ALL_PRODUCT:
                title = '全部商品 | inif印衣服，巧昱服飾設計有限公司';
                break;
            case window.STATES.CART:
                title = '購物車 | inif印衣服，巧昱服飾設計有限公司';
                break;
            case window.STATES.ORDER:
            case window.STATES.ORDER_LIST:
            case window.STATES.ORDER_LIST_ALL:
            case window.STATES.ORDER_LIST_PAY:
            case window.STATES.ORDER_LIST_DISCARD:
            case window.STATES.ORDER_LIST_SUCCESS:
            case window.STATES.ORDER_HISTORY:
                title = '訂單中心 | inif印衣服，巧昱服飾設計有限公司';
                break;
            case window.STATES.OTHER:
                title = '帳戶中心 | inif印衣服，巧昱服飾設計有限公司';
                break;
            case window.STATES.MEMBER_SYSTEM_MESSAGE:
                title = '消息中心 | inif印衣服，巧昱服飾設計有限公司';
                break;
            case window.STATES.ABOUT:
                title = '關於我們 | inif印衣服，巧昱服飾設計有限公司';
                break;
            case window.STATES.FAQ:
                title = '常見問題 | inif印衣服，巧昱服飾設計有限公司';
                break;
            // 這些state更換title在各自的controller做
            case window.STATES.ENTERPRISE_SIGNUP:
            case window.STATES.POINTS_MONTHLY_INTRODUCTION:
            case window.STATES.POINTS_INTRODUCTION:
            case window.STATES.PRODUCT_LIST:
            case window.STATES.PRODUCT:
            case window.STATES.COMPLEX_PDT:
            case window.STATES.FAQ_CONTENT:
            case window.STATES.BLOG_LIST:
            case window.STATES.RESOURCE_LIST:
            case window.STATES.DESIGNER_LIST:
            case window.STATES.PROJECT_LIST:
            case window.STATES.BLOG_POST:
            case window.STATES.PROJECT_POST:
            case window.STATES.DESIGNER:
                return;
            // mobile
            default:
                title = inifECTitle;
                break;
        }

        setWebTitle(title);
    }

    // --------------------------------
    // 設定標題名稱
    // --------------------------------
    var setWebTitle = function(title) {

        if(title) {
            document.title = title;
        } else {
            document.title = inifECTitle;
        }
    }

    // --------------------------------
    // 回覆原始標題
    // --------------------------------
    var resetWebTitle = function(){
        document.title = inifECTitle;
    }

    // --------------------------------
    // 設定商品列表標題名稱
    // --------------------------------
    var setPdtClassWebTitle = function(pdtClass) {

        var title = inifECTitle;

        if(pdtClass && pdtClass.seoTitle) {
            title = pdtClass.seoTitle;
        }

        setWebTitle(title);
    }

    /*==========================
        Methods
    ==========================*/
    _factory.changeWebTitle = changeWebTitle;
    _factory.changeMobileWebTitle = changeMobileWebTitle;
    _factory.setWebTitle = setWebTitle;
    _factory.resetWebTitle = resetWebTitle;
    _factory.setPdtClassWebTitle = setPdtClassWebTitle;

    /*==========================
        Init
    ==========================*/

    return _factory;

}]);